export class Patient {
    AutoIndex
    ID: string;
    First: string;
    Last: string;
    FirstEng: string;
    LastEng: string;
    IsID: number = 1;
    IsPreganant: boolean = true;
    LMP: string;
    Birth: string;
    Height: number
    Weight: number
    Email: string
    Mobile: string
    Mobile2: string
    Mobile3: string
    Phone: string
    Phone2: string
    Phone3: string
    Address: string
    City: string
    Zip: string
    BloodType: string
    HMO: string
    RefferDoc: string
    Comments: string
    DBIndex: number 
    PID: number//for fetching purposes
    UID: number
    //for awl
    Status: string;
    AWLID:number;
    ExamLMP;
    ExamType: string;
    ExamCode: string;
    HMOExamCode: string;
    HMOExamName: string;
    Reason:string;
    PRN: string;
    Code: string;
    Sex: string;
    BSAus: number | null;
    refDocName  :string;
    BranchProviderID:number;
    BranchProviderName :number;
    refDocLastName:string;
    PRN2: string;
    Code2: string;
    refDocName2  :string;
    BranchProviderID2:number;
    BranchProviderName2 :number;
    refDocLastName2:string;




    constructor(id: string = null, fname: string = null, lname: string = null, phone: string = null, HMO:string = null){
        this.ID=id
        this.First=fname
        this.Last=lname
        this.Phone=phone
        this.HMO = HMO
    }
    

    getGA():string{
        if(! this.LMP)
            return "";
        
        let days = Math.round((Date.now() - Date.parse(this.LMP))/(1000 * 60 * 60 *24));
        if(days/7 <= 42)
            return Math.floor(days/7) + "w " + (days % 7) + "d";
        return null;
    }

    getAge(atDate:Date = new Date()):string{
        if(! this.Birth)
            return "";
        let days = Math.round((atDate.valueOf() - Date.parse(this.Birth))/(1000 * 60 * 60 *24));
        return Math.floor(days/36.525) / 10 + " yrs";
    }

    getAgeMo(atDate:Date = new Date()){
        if(! this.Birth)
            return "";
        let days = Math.round((atDate.valueOf() - Date.parse(this.Birth))/(1000 * 60 * 60 *24));
        let years = Math.floor(days/365.25);
        let part = days - years * 365.25;
        return Math.floor(days/365.25) + "y" + Math.floor(part/30)+"m";
    }

    asignVals(pat){
        for (let key in pat) {
            try{
                this[key] = pat[key]
            }
            catch{}
            // Use `key` and `value`
        }
        this.IsPreganant = (pat["IsPreganant"] == 1)
    }
}